import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[cubeDynamic]',
})
export class DynamicDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
